import produce from 'immer';

const INITIAL_STATE = {
  data: null,
};

export default function atividades(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@atividades/SALVAR': {
        draft.data = action.payload.atividades;
        break;
      }
      case '@unidade/UNIDADE_SELECIONADA_SUCCESS': {
        draft.data = null;
        break;
      }
      case '@unidade/UNIDADE_SELECIONADA_FAILURE': {
        draft.data = null;
        break;
      }
      case '@auth/SIGN_OUT': {
        draft.data = null;
        break;
      }
      default:
    }
  });
}
